
<ng-container *ngIf="isLoaded">
  <div style="text-align: right; font-size: 17px; margin-right: 20px; margin-top: 5px; font-weight: 600 " (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Редакция на Ремонта Група</h5>
        <p class="text-center small">Моля, направете нужните промени</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="title" class="form-label">Име</label>
          <input type="text" formControlName="title" class="form-control" id="title" value="{{editObject.title}}">
        </div>
        <div class="col-12 mb-3">
          <label for="regionId" class="form-label">Роля</label>
          <select formControlName="regionId" class="form-select">
            <option value="" disabled>Изберете Роля</option>
            <option *ngFor="let region of regions" [value]="region.id" [selected]="+region.id === +editObject.regionId">{{ region.title.replace('_',' ') }}</option>
          </select>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Активна</label>
          </div>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Промени</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
<ng-container *ngIf="!isLoaded">
  <div style="text-align: center;">
    <div class="spinner-grow spinner-grow-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-container>
